// extracted by mini-css-extract-plugin
export default {"wrapperNotFound":"style_wrapperNotFound__2JERN"};